<template>
<div>
    <div class="image">
        <img src="/images/common/404.png">
    </div>
    <h2>Sorry, the page you're looking for can't be found.</h2>
    <div class="links">
        <router-link to="/">Back to Home</router-link>
        <router-link to="">Go Back</router-link>
    </div>
</div>
</template>

<script>
    export default {
        name: "404",
    }
</script>

<style scoped>

</style>
